import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { EOLComponent } from 'src/app/pages/eol/eol.page';

const routes: Routes = [
  {
    path: '',
    component: EOLComponent,
    data: { title: 'End of Life' },
  },
  {
    path: '**',
    redirectTo: '',
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
